import { FC } from 'react';

import { IconName } from '@purpur/library/icon';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { AdaptiveIcon } from '../components/AdaptiveIcon/AdaptiveIcon';
import { PriceTag } from '../components/PriceTag';
import { ORDER_CART_ENTRY_ID, ORDER_CART_TEST_ID } from '../constants';
import { Price } from '../model';
import { SimCardEntryListItem } from './entries.styles';

type SimCardEntryProps = {
    isEsim: boolean;
    price: Price;
};

export const SimCardEntry: FC<SimCardEntryProps> = ({ isEsim, price }) => {
    const { t } = useTranslations();
    const text = isEsim ? t['order_cart.entry_sim_card.esim_text'] : t['order_cart.entry_sim_card.sim_text'];
    const icon: IconName = isEsim ? 'esim-simcard' : 'simcard';

    return (
        <SimCardEntryListItem data-test={ORDER_CART_ENTRY_ID.SIM_CARD} aria-label={text}>
            <AdaptiveIcon icon={icon} />
            <span data-test={ORDER_CART_TEST_ID.ENTRY_TITLE_SIM_CARD}>{text}</span>
            <PriceTag price={price} dataTest={ORDER_CART_TEST_ID.PRICE_SIM_CARD} />
        </SimCardEntryListItem>
    );
};
